import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Route, Redirect } from 'react-router-dom';
import { ApolloProvider } from 'react-apollo';
import { getClient } from '~/graphql/client';
import { actions as BreweryActions } from '~/redux/brewery';
import Spinner from '../spinner/spinner';

export class PrivateRoute extends Component {
  componentDidMount() {
    const { brewery, breweries, setBrewery } = this.props;
    if (!breweries || brewery) {
      // The user either has no breweries or has already set one, so do nothing
      return;
    }

    if (breweries.length === 1) {
      // User only has one brewery, select that one and be on our merry way
      setBrewery(breweries[0]);
      return;
    }

    // If there are more than one brewery and the user has selected that brewery before,
    // go to that brewery.
    const lastSelectedBreweryId = localStorage.getItem(`tb_${this.props.auth.profile.id}_lastSelectedBreweryId`);
    if (breweries.length > 1 && lastSelectedBreweryId) {
      const brewery = breweries.find(b => b.id == lastSelectedBreweryId); // eslint-disable-line
      if (brewery) {
        // Got it. Set
        setBrewery(brewery);
      } else {
        // We don't have that brewery, so just select the first one.
        setBrewery(breweries[0]);
      }
    } else if (breweries.length) {
      // Just set a brewery - should prob show the selectBrewery page really
      setBrewery(breweries[0]);
    }
  }

  // redirect if not authenticated; otherwise, return the component imputted into <PrivateRoute />
  handleRender = () => {
    const { auth, brewery, breweries, location } = this.props;
    // Not logged in, go to login screen
    if (!auth.loggedIn) {
      return (
        <Redirect
          to={{
            pathname: `/login?redirectTo=${location.pathname.slice(1)}`
          }}
        />
      );
    }

    if (!brewery && location.pathname !== '/selectbrewery') {
      // There's no brewery set yet and the page isn't the select brewery page. Wait until brewery is set
      return (
        <div className="vh-100 w-100 flex justify-center items-center">
          <Spinner />
        </div>
      );
    }

    if (breweries.length > 1 && !brewery) {
      // User has more than one brewery and hasn't yet selected one. Go to the select screen
      return (
        <Redirect
          to={{
            pathname: `/selectbrewery`
          }}
        />
      );
    }

    const ComposedComponent = this.props.component;
    return (
      <ApolloProvider client={getClient()}>
        <ComposedComponent {...this.props} />
      </ApolloProvider>
    );
  };

  render() {
    const rest = {
      ...this.props
    };
    delete rest.component;

    return <Route {...rest} render={this.handleRender.bind(this)} />;
  }
}

function mapStateToProps(state) {
  return {
    brewery: state.brewery,
    breweries: state.breweries,
    auth: state.auth
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setBrewery: BreweryActions.setBrewery
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PrivateRoute);



// WEBPACK FOOTER //
// ./src/components/privateRoute/privateRoute.jsx